import { render, staticRenderFns } from "./SearchReferences.vue?vue&type=template&id=763085a2&scoped=true"
import script from "./SearchReferences.vue?vue&type=script&lang=js"
export * from "./SearchReferences.vue?vue&type=script&lang=js"
import style0 from "./SearchReferences.vue?vue&type=style&index=0&id=763085a2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "763085a2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('763085a2')) {
      api.createRecord('763085a2', component.options)
    } else {
      api.reload('763085a2', component.options)
    }
    module.hot.accept("./SearchReferences.vue?vue&type=template&id=763085a2&scoped=true", function () {
      api.rerender('763085a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/umesr/components/SearchReferences.vue"
export default component.exports